import { BrowserRouter, Routes, Route } from 'react-router-dom';
import MainPage from '@/messages/MainPage';
import AdminPage from '@/admin/AdminPage';
import LoginModal from "@/user/LoginModal";
import { useAppSelector } from "@/store";

export default function App() {
  const userId = useAppSelector((s) => s.user.userId);

  return (
    <BrowserRouter>
      <LoginModal isOpen={!userId} />

      <Routes>
        <Route path="/*" element={<MainPage />} />
        <Route path="/admin" element={<AdminPage />} />
      </Routes>
    </BrowserRouter>
  );
}
